import { UserAuthStore } from 'stores';
import { Program } from 'models';

const updateUserProgramRelationship = async (
  userAuth: UserAuthStore,
  program: Program,
  pid: string,
  camref: string,
  accName: string,
) => {
  try {
    const { brand, posa, network } = program;
    const response = await userAuth.updateUserProgramRelationship(brand, posa, network, pid, false, camref, accName);

    if (response.status === 201) {
      return true;
    } else {
      throw response;
    }
  } catch (e) {
    throw e;
  }
};

export default updateUserProgramRelationship;
